import React, {useEffect, useState} from 'react';
import {Box, TablePagination} from "@mui/material";
import CustomSearch from "../components/common/CustomSearch";
import SearchComponent from "../components/searchComponent/SearchComponent";
import DailyReconciliationList from "../components/dailyReconcelation/DailyReconcelationList";
import {useTypedSelector} from "../store";
import {setReviewFilterData} from "../store/review/review.slice";

const DailyReconciliation = () => {
    // Filter actions
    const [query, setQuery] = useState('')
    const [string, setString] = useState('')
    const handleClear = () => {
        setString('')
        setQuery('')
    }
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setString(event.target.value)
    }
    const handleSubmit = () => {
        setQuery(string)
    }
    const values = {
        query: string
    }


    // Pagination actions
    const {reconciliationsCount} = useTypedSelector(state => state.calendar)
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    const children = (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                <div style={{marginRight: "20px"}}>
                    <CustomSearch field={"query"} handleChange={handleChange} placeholder={"Врач, услуга, процедура"}
                                  width={"300px"} name={"query"} values={values} handleSubmit={handleSubmit}
                                  handleClear={handleClear}/>
                </div>

            </div>

            <div>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={
                        reconciliationsCount || 0}
                    rowsPerPage={rowsPerPage}
                    page={page as number}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage=""
                    sx={{marginBottom: "10px"}}
                />
            </div>


        </Box>
    )

    return (
        <>
            <SearchComponent children={children}/>
            <DailyReconciliationList rowsPerPage={rowsPerPage} query={query} filterPage={page + 1}/>
        </>
    );
};

export default DailyReconciliation;